import store from "../../Redux/store";
import {
  countRepositorySdgs,
  setRepositorySdgs,
} from "./RepositorySdgs.reducer";

export function saveListRepositorySdgs(records) {
  store.dispatch(setRepositorySdgs(records));
}

export function saveCountRepositorySdgs(count) {
  store.dispatch(countRepositorySdgs(count));
}
